export default "__VITE_ASSET__BqT0jNUL__"